import { z } from 'zod'

import { schemas } from '~interface/zod-schema'
import { Address0 } from '~types'

export type Value0 = z.infer<typeof schemas.Value0>
export type BoolValue0 = z.infer<typeof schemas.BoolValue0>
export type DatetimeValue0 = z.infer<typeof schemas.DatetimeValue0>
export type FileValue0 = z.infer<typeof schemas.FileValue0>
export type IdentityValue0 = z.infer<typeof schemas.IdentityValue0>
export type LocationValue0 = z.infer<typeof schemas.LocationValue0>
export type NumberValue0 = z.infer<typeof schemas.NumberValue0>
export type TextValue0 = z.infer<typeof schemas.TextValue0>
export const ExpressionOperatorEnum = schemas.ExpressionOperatorEnum
export type ValueCreate = z.infer<typeof schemas.ValueCreate>

export interface IdentityInformation {
  first_name?: { value: string | null; existed: boolean }
  last_name?: { value: string | null; existed: boolean }
  email?: { value: string | null; existed: boolean }
  phone?: { value: string | null; existed: boolean }
  address?: { value: Address0; existed: boolean }
  birthday?: { value: string | null; existed: boolean }
  emailOverride?: string | null // when user puts in someone else's info on case apply
}
